import { combineReducers } from 'redux';
import { LOGIN_SUCCESS, LOGIN_FAILURE, SET_USER, SET_MENU, SET_COMPANYS } from '../actions';

const initialStateUser = {
  user: null,
  error: null,
  isAuthenticated: false,
};

const authReducer = (state = initialStateUser, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        error: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: !!action.payload, // Autenticado si existe el usuario
      };
    default:
      return state;
  }
};

const initialStateMenu = {
  menu: 'empresaAct',
};

const menuReducer = (state = initialStateMenu, action) => {
  switch (action.type) {
    case SET_MENU:
      return {
        ...state,
        menu: action.payload,
      };
    default:
      return state; 
  }
}

const inicialStateCompanys = {
  companys: [],
};

const companysReducer = (state = inicialStateCompanys, action) => {
  switch (action.type) {
    case SET_COMPANYS:
      return {
        ...state,
        companys: action.payload,
      }
    default:
      return state;
  }
};

// Combinar los reducers
const rootReducer = combineReducers({
  auth: authReducer,
  menu: menuReducer,
  companys: companysReducer,
});

export default rootReducer;
